import touch  from '@common/touch/touch'

import getOs from './getOs'

/**
 * Ez egy iPadOS eszköz?
 * @param ua - UserAgent.
 */
export default function isIPadOS (ua: string): boolean { // eslint-disable-line @typescript-eslint/naming-convention
  const os = getOs(ua)

  return os === 'Mac OS' && touch.isTouchSupported()
}
